module.exports = __webpack_public_path__ + "static/img/081_TO8_1728.370c193.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/081_TO8_1728.jpg
// module id = Q1Fi
// module chunks = 0